<template>
    <div class="d-flex " :class="expand?'flex-column':'flex-row'">
        <div class="d-flex flex-row" :class="expand?'flex-wrap w-100':'overflow-auto fold-filter flex-grow-1 mr-1'">
            <template v-for="item of options">
                <mini-input :key="item.key"
                            :ref="item.key"
                            class="mr-1 filter-item"
                            :type="inputType(item)"
                            :value.sync="filterForm[item.key]"
                            :options="item.field.options"
                            :options-from-dict="item.field.optionsFromDict"
                            :label="item.label"
                            @change="emit"
                            @enter="emitSearchDelay"></mini-input>
            </template>
        </div>
        <div class="d-flex flex-shrink-0" :class="expand?'mt-1':'m-tb-auto'">
            <div class="ml-auto"></div>
            <b-button variant="outline-secondary" class="mr-1" @click="expand=!expand">
                <i class="fa-solid" :class="!expand?'fa-angles-down':'fa-angles-up'"></i>
            </b-button>
            <b-button variant="outline-secondary" class="mr-1" @click="handleReset">
                <i class="fa fa-fw fa-lg fa-eraser"></i>
                <span class="text">{{ $t("btn.basic.clear") }}</span>
            </b-button>
            <mini-button :loading="searchLoading" variant="primary" class="search-btn"
                         @btnClick="emitSearch">
                <i class="fa fa-fw fa-lg fa-search"></i>
                <span class="text">{{ $t("btn.basic.search") }}</span>
            </mini-button>
        </div>
    </div>
</template>

<script>

import MiniInput from "@/components/common/inputs/MiniInput.vue";
import emCommonUtilMixin from "@/mixin/em/common/stuffs/utils/emCommonUtilMixin";
import MiniButton from "@/components/common/buttons/MiniButton.vue";

const OP = [
    {name: 'In', label: '包含/In', onlyType: 'select'},
    {name: 'ILike', label: '包含/Like', onlyOrigin: 'String'},
    {name: 'Between', label: '介于之间', onlyOrigin: 'Date'},
    {name: 'Eq', label: '等于', notOrigin: 'Date', notType: 'select'},
];
export default {
    name: "TableFilter",
    components: {MiniButton, MiniInput},
    mixins: [emCommonUtilMixin],
    props: {
        fields: Array,
        searchLoading: Boolean,
    },
    data() {
        return {
            notAccept: new Set(['image']),
            filters: {},
            filterForm: {},
            expand: false,
        }
    },
    computed: {
        options() {
            let tempList = [];
            if (this.fields) {
                for (let item of this.fields) {
                    if (item.visible || this.showInvisible) {
                        let type = item.type;
                        if (this.notAccept.has(type)) {
                            continue;
                        }
                        let transLabel = this.$t(item.label);
                        for (let op of OP) {
                            if (op.onlyOrigin && op.onlyOrigin !== item.originalType
                                || op.onlyType && op.onlyType !== type
                                || op.notOrigin && op.notOrigin === item.originalType
                                || op.notType && op.notType === type) {
                                continue;
                            }
                            tempList.push({
                                label: transLabel,
                                key: item.key + op.name,
                                op: op.name,
                                field: item,
                            })
                            break;
                        }
                    }
                }
            }
            return tempList;
        },
    },
    methods: {
        inputType(item) {
            if (item.op === 'In') {
                return 'select-multi';
            } else if (item.op === 'Between') {
                return 'date-range';
            } else {
                return item.field.type;
            }
        },
        emit() {
            this.$emit('change', this.filterForm);
        },
        emitSearch() {
            this.cardOpen = false;
            this.$emit("search", this.filterForm);
        },
        emitSearchDelay() {
            this.$nextTick(() => this.emitSearch());
        },
        handleReset() {
            this.filterForm = {};
            this.emit();
        },
    }
}
</script>

<style scoped lang="scss">
.filter-item {
    width: 200px !important;
    min-width: 200px;
}

.search-btn {
    width: 90px;
}

.fold-filter {
    &::-webkit-scrollbar {
        height: 3px !important;
        background-color: #fafafa;
    }

    &::-webkit-scrollbar-thumb {
        background-color: #c0c0c0;
        border-radius: 6px;
    }

    &::-webkit-scrollbar-thumb:hover {
        background-color: #7c7c7c;
    }

    &::-webkit-scrollbar-corner {
        background-color: #fafafa;
    }
}
</style>
